import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { toggleTaskComplete } from "../api/todo.api";
import { CreateTaskResponse, TodoListType } from "../api/type";

type Vars = { id: number; completato: 0 | 1 };
type Ctx = { previous: TodoListType[] };

export function useToggleTaskComplete() {
  const queryClient = useQueryClient();

  return useMutation<CreateTaskResponse, unknown, Vars, Ctx>({
    mutationFn: toggleTaskComplete,

    onMutate: async ({ id, completato }) => {
      await queryClient.cancelQueries({ queryKey: ["task-list"] });
      const previous = queryClient.getQueryData<TodoListType[]>(["task-list"]) ?? [];
      queryClient.setQueryData<TodoListType[]>(["task-list"], (current = []) =>
        current.map((t) => (t.id === id ? { ...t, completato } : t))
      );
      return { previous };
    },

    onError: (_err, _vars, ctx) => {
      if (!ctx) return;
      queryClient.setQueryData(["task-list"], ctx.previous);
      toast.error("Errore aggiornamento task");
    },

    onSuccess: (res) => {
      if (res.status === "ok") toast.success(res.message ?? "Task aggiornata");
      else toast.error(res.message ?? "Errore aggiornamento task");
    },

    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["task-list"] });
    },
  });
}
